import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { OidcProvider, TokenRenewMode } from "@axa-fr/react-oidc";
import API from "./helpers/API";
import { LoaderAllaboxIcon } from "./Components/common/LoaderAllaboxIcon";
import { AppProvider } from "./AppProvider";
import { config } from "@fortawesome/fontawesome-svg-core";
import "@fortawesome/fontawesome-svg-core/styles.css";

config.autoAddCss = false;

const root = ReactDOM.createRoot(document.getElementById("root"));
const api = new API();
const configuration = {
  client_id: "allabox",
  redirect_uri: window.location.origin + "/authentication/callback",
  silent_redirect_uri:
    window.location.origin + "/authentication/silent-callback",
  scope: "openid profile",
  authority: `https://auth.${api.getURL()}`,
  refresh_time_before_tokens_expiration_in_second: 40,
  service_worker_relative_url: "/OidcServiceWorker.js",
  service_worker_only: false,
  storage: window.sessionStorage,
  token_request_extras: {
    client_secret: "e21767fa-47cf-4932-9e84-75fa7b9b465e",
  },
  token_renew_mode: TokenRenewMode.access_token_invalid,
  post_logout_redirect_uri: window.location.origin + "/",
};

root.render(
  <OidcProvider
    authenticatingComponent={() => <LoaderAllaboxIcon show={true} />}
    loadingComponent={() => (
      <React.Fragment>
        <LoaderAllaboxIcon show={true} />
      </React.Fragment>
    )}
    configuration={configuration}
    onSessionLost={() => console.error("Sessione persa!")}
  >
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <AppProvider>
        <App />
      </AppProvider>
    </BrowserRouter>
  </OidcProvider>,
);
